<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="A4_">
<div class="image" id="pz18-5"><img alt="images/himg-18-1.jpg" id="z18-5" src="images/himg-18-1.jpg"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter13.vue?5fc92a7b